import { useState } from "react";
import Api from "../../Api";
import EntitySearch from "../../parts/EntitySearch";
import Section from "../../parts/Section";
import EntityList from "../../parts/EntityList";
import { useNavigate } from "react-router-dom";
import { Client } from "../../types";

const FinanceReceiptsClients = () => {
  const [data, setData] = useState<Client[] | null>(null);

  return (
    <>
      <div className="border-b">
        <Section className="p-4">
          <EntitySearch
            searchFunction={Api.financeReceiptsClients}
            setEntities={setData}
          />
        </Section>
      </div>

      <Section>
        <EntityList entities={data} Card={ClientCard} />
      </Section>
    </>
  );
};

export default FinanceReceiptsClients;

const ClientCard = ({ entity: client }: { entity: Client }) => {
  const navigate = useNavigate();
  return (
    <div className="border rounded-lg shadow-sm flex flex-col">
      <div
        className="overflow-scroll whitespace-nowrap no-scrollbar font-semibold p-4 cursor-pointer hover:bg-slate-50"
        onClick={() => navigate(`/financeiro/recibos/cliente/${client.uuid}`)}
      >
        {client.name}
      </div>
    </div>
  );
};
